// import { createContext, useState, useEffect } from "react";

// export const LanguageContext = createContext();

// export const LanguageProvider = ({ children }) => {
//   const [lang, setLang] = useState(() => {
//     return localStorage.getItem("lang") || "ar";
//   });

//   useEffect(() => {
//     localStorage.setItem("lang", lang);
//   }, [lang]);

//   return (
//     <LanguageContext.Provider value={{ lang, setLang }}>
//       {children}
//     </LanguageContext.Provider>
//   );
// };

import { createContext, useState, useEffect } from 'react';

export const LanguageContext = createContext();

const SUPPORTED = ['eng', 'ar', 'fr', 'es', 'sw'];
const DEFAULT_LANG = 'sw';

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('lang');
    return SUPPORTED.includes(saved) ? saved : DEFAULT_LANG;
  });

  useEffect(() => {
    localStorage.setItem('lang', lang);
    document.body.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};
